import { useEffect, useState } from 'react';
import { toast } from 'react-hot-toast';
import { useHistory } from 'react-router-dom';
import { Button } from 'src/components';
import DeleteInformationModal from 'src/components/DeleteInformation/DeleteInformationModal';
import { useDeleteApprovalMutation } from 'src/rtk/features/setup/approval/approvalApi';
import { useGetOrganizationsQuery } from 'src/rtk/features/setup/organization/setupOrganizationApi';

interface Props {
  approval: Approval;
  index: number;
}

const ApprovalTableRow = ({ approval, index }: Props) => {
  const history = useHistory();
  
  const [infoId, setInfoId] = useState('');
  const [modalShow, setModalShow] = useState(false);

  const [deleteApproval, { isSuccess, isLoading, isError }] =
    useDeleteApprovalMutation();
  const { data } = useGetOrganizationsQuery();
  const organizations = data?.data;

  const deleteHandler = (modalState: boolean, id: string) => {
    setModalShow(modalState);
    setInfoId(id);
  };

  useEffect(() => {
    if (isSuccess) {
      toast.success('Approval deleted successfully');
    }
    if (isError) {
      toast.error('Error deleting approval');
    }
  }, [isSuccess, isError]);

  return (
    <tr key={approval.id}>
      <th scope="row">{index + 1}</th>
      <td>{approval.module_name}</td>
      <td>{approval.table_name}</td>
      <td>{approval.page_name}</td>
      <td>{approval.total_step}</td>
      <td>{approval.minimum_step}</td>
      <td>{approval.status ? 'Active' : 'Inactive' || 'N/A'}</td>

      <td>
        <div className="d-flex gap-2">
          <Button
            size="sm"
            text="Edit"
            color="warning"
            onClick={() =>
              history.push(`/setup/approval/update/${approval.id}`)
            }
          />

          <Button
            size="sm"
            text="Delete"
            color="danger"
            disabled={isLoading}
            isLoading={isLoading}
            onClick={() => deleteHandler(true, approval.id!)}
          />
        </div>
        {modalShow ? (
          <DeleteInformationModal
            isOpen={modalShow}
            toggle={() => setModalShow(!modalShow)}
            id={infoId}
            deleteInfomation={deleteApproval}
          />
        ) : null}
      </td>
    </tr>
  );
};

export default ApprovalTableRow;
